import React from 'react'
import "./Contact.css"
import { TfiLayoutLineSolid } from "react-icons/tfi";
import { PiHouseLineThin } from "react-icons/pi";
import { FaPhoneAlt } from "react-icons/fa";
import { IoIosMail } from "react-icons/io";
import { CiClock2 } from "react-icons/ci";
import Emailjs from '../Email/Email';
import Map from '../Map/Map';

const Contact = () => {
    return (
        <div className='contact-main' id='cont'>
            <div className="contact-container">
                <div className="contact-top">
                    <div className="contact-head">
                        <span><TfiLayoutLineSolid />Get In Touch</span>
                    </div>
                    <div className="contact-text">
                        <span>Let's open the conversation.</span>
                    </div>
                    <div className="contact-end">
                        <span>Reach out for a free, no-obligation consultation — or stop by the Patiala office in person.</span>
                    </div>
                </div>
                <div className="contact-center">
                    <div className="contact-left">
                        <Emailjs />
                    </div>
                    <div className="contact-right">
                        <div className="contact-add">
                            <div className="contact-icon">
                                <span><PiHouseLineThin /></span>
                            </div>
                            <div className="contact-brief">
                                <h1>Office Address</h1>
                                <span>Profit Station
                                    [1ST FLOOR, SCO-45, near HDFC BANK, DLF COLONY, Tripuri, Sirhind Road], Patiala, Punjab, India</span>
                            </div>

                        </div>
                        <div className="c-line" />
                        <div className="contact-add">
                            <div className="contact-icon">
                                <span><FaPhoneAlt /></span>
                            </div>
                            <div className="contact-brief">
                                <h1>Phone</h1>
                                <span>+91 96465 55699</span>
                            </div>

                        </div>
                        <div className="c-line" />
                        <div className="contact-add">
                            <div className="contact-icon">
                                <span><IoIosMail /></span>
                            </div>
                            <div className="contact-brief">
                                <h1>Email</h1>
                                <span>profitstation99@gmail.com</span>
                            </div>

                        </div>
                        <div className="c-line" />
                        <div className="contact-add">
                            <div className="contact-icon">
                                <span><CiClock2 /></span>
                            </div>
                            <div className="contact-brief">
                                <h1>Office Hours</h1>
                                <span>Mon - Sat: 9:30 AM - 6:30 PM
                                    Sunday: Closed</span>
                            </div>

                        </div>
                        <div className="c-line" />


                        <div className="addres map">
                            <Map />
                        </div>

                    </div>
                </div>

            </div>
        </div>
    )
}

export default Contact